import React from "react"
import {Box} from "@mui/material"
import ValidationMemoryTable from "./validation-memory-table"
import {VALIDATION_MEMORY_COLUMNS} from "./validation-memory"
import {
    normalizedValidationMemoriesPropType,
    normalizedValidationPremiosPropType,
} from "./validation-contract"

const ILLUSTRATIVE_REPURCHASE_COLUMNS = Array.from({length: 5}, (_, index) => ({
    field: `illustrative-repurchase-column-${index + 1}`,
    headerName: "",
    minWidth: 160,
}))

const ValidationMemoriesSection = ({memories, premios}) => (
    <Box sx={{display: "flex", flexDirection: "column", gap: 4, mt: 4}}>
        <ValidationMemoryTable
            title="Memória de Cálculo PUPAR"
            columns={VALIDATION_MEMORY_COLUMNS.pupar}
            rows={memories.pupar}
        />
        <ValidationMemoryTable
            title="Memória de Cálculo PUMTM"
            columns={VALIDATION_MEMORY_COLUMNS.pumtm}
            rows={memories.pumtm}
        />
        <ValidationMemoryTable
            title="Memória de Cálculo Fator de Correção"
            columns={VALIDATION_MEMORY_COLUMNS.fatorCorrecao}
            rows={memories.fatorCorrecao}
        />
        {premios.conversibilidade.aplicavel && (
            <ValidationMemoryTable
                title="Memória de Cálculo Prêmio de Conversibilidade"
                columns={VALIDATION_MEMORY_COLUMNS.conversibilidade}
                rows={premios.conversibilidade.memoria}
            />
        )}
        {premios.recompra.aplicavel && (
            <ValidationMemoryTable
                title="Memória de Cálculo Prêmio de Recompra"
                columns={ILLUSTRATIVE_REPURCHASE_COLUMNS}
                rows={[]}
            />
        )}
    </Box>
)

ValidationMemoriesSection.propTypes = {
    memories: normalizedValidationMemoriesPropType.isRequired,
    premios: normalizedValidationPremiosPropType.isRequired,
}

export default ValidationMemoriesSection
